module.exports = __webpack_public_path__ + "img/appAsset-brand--piriod-icon.36df673a.svg";